import React from 'react';
import styled from 'styled-components';

import { Black } from '../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';
import ContentWrap from './content_wrap/index';
import Headings from './headings/index';

const Wrap = styled.div`
  color: ${Black};
  display: grid;
  grid-column-gap: 1.5rem;
  overflow-x: hidden;
  padding-top: 48px;
  padding-bottom: 80px;
  background: ${({ bgColor }) => bgColor || '#fcfcfc'};
  @media ${breakpointsMinWidth.mobileMd} {
    grid-template-columns: repeat(4, 1fr);
    padding: 0px 16px 0px;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-template-columns: repeat(8, 1fr);
    padding: 0px 0px 0px;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
    padding: 0px 0px 0px;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
`;

const WhyWisedoc = ({ data, bgColor }) => {
  return (
    <>
      <Wrap id="features-and-benefits" bgColor={bgColor}>
        <Headings data={data} />
        <ContentWrap data={data} />
      </Wrap>
    </>
  );
};

export default WhyWisedoc;
